import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { combineExtensionProviders } from '@atlaskit/editor-common/extensions';
import { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import { CardClient, SmartCardProvider } from '@atlaskit/link-provider';
import { RendererWithAnalytics as AkRenderer } from '@atlaskit/renderer';
import { ExtensionMode, HubRendererWrapper } from '@atlassian/company-hub-common';
import { getSectionExtensionContents } from '@atlassian/hub-providers';
import { sectionExtensionProvider } from '@atlassian/section-extension';
import { useHubExtensionHandlers } from '../../controllers/use-hub-extension-handlers';
export var HubRenderer = function HubRenderer(props) {
  var product = props.product,
    _props$additionalExte = props.additionalExtensionHandlers,
    additionalExtensionHandlers = _props$additionalExte === void 0 ? {} : _props$additionalExte,
    PropsProvider = props.PropsProvider,
    contentId = props.contentId,
    dataProviders = props.dataProviders;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    sectionsProvider = _useState2[0],
    setSectionsProvider = _useState2[1];
  var intl = useIntl();
  var hubExtensionHandlers = useHubExtensionHandlers({
    contentId: contentId,
    PropsProvider: PropsProvider
  });
  var allExtensionHandlers = useMemo(function () {
    return _objectSpread(_objectSpread({}, hubExtensionHandlers), additionalExtensionHandlers);
  }, [hubExtensionHandlers, additionalExtensionHandlers]);
  useEffect(function () {
    var loadSectionsProvider = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var defaultExtensionProviderProps, defaultExtensionInstanceProps, sectionsProviderInstance, sectionsProvider;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: ExtensionMode.RENDERER,
                getSectionExtensionContents: getSectionExtensionContents
              };
              defaultExtensionInstanceProps = {
                intl: intl,
                contentId: contentId
              };
              _context.next = 4;
              return sectionExtensionProvider(defaultExtensionProviderProps);
            case 4:
              sectionsProviderInstance = _context.sent;
              _context.next = 7;
              return sectionsProviderInstance(defaultExtensionInstanceProps);
            case 7:
              sectionsProvider = _context.sent;
              setSectionsProvider(sectionsProvider);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadSectionsProvider() {
        return _ref.apply(this, arguments);
      };
    }();
    loadSectionsProvider();
  }, [contentId, intl, PropsProvider]);
  var providerFactory = useMemo(function () {
    var factory = dataProviders || ProviderFactory.create({});
    if (sectionsProvider) {
      factory.setProvider('extensionProvider', Promise.resolve(combineExtensionProviders([sectionsProvider])));
    }
    return factory;
  }, [sectionsProvider, dataProviders]);
  var smartCardClient = useMemo(function () {
    return new CardClient();
  }, []);
  return /*#__PURE__*/React.createElement(HubRendererWrapper, {
    "data-testid": "hub-renderer"
  }, /*#__PURE__*/React.createElement(SmartCardProvider, {
    product: product,
    client: smartCardClient
  }, /*#__PURE__*/React.createElement(AkRenderer, _extends({}, props, {
    extensionHandlers: allExtensionHandlers
    // dataProviders supplies the extension provider factory which enables section extensions to be rendered within the hub
    ,
    dataProviders: providerFactory,
    adfStage: "stage0"
  }))));
};
export default HubRenderer;